module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "shop"
  }, [_c('h1', [_vm._v(_vm._s(_vm.shop.name))]), _vm._v(" "), _c('div', {
    staticClass: "shop-map"
  }, [_c('div', {
    staticClass: "shop-desc"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.shop.img,
      "width": "90%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('add_address_address')) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.shop.address))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.shop.num))])]), _vm._v(" "), _c('div', {
    staticClass: "business-hours"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('office_hours')) + ":")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('monday_friday')))]), _vm._v(" "), _c('span', [_vm._v("10 am ~ 10 pm")])]), _vm._v(" "), _c('p', {
    staticClass: "time",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "map_showpace"
  }, [_c(_vm.currentTab, {
    tag: "first",
    attrs: {
      "keep-alive": ""
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc9afa3e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = 858
// module chunks = 0